import React, { useState, useEffect } from "react";
import styled from "styled-components";
import fadeimg1 from "../images/inst1.webp";
import fadeimg2 from "../images/insit2.jpg";
import fadeimg3 from "../images/shopper.jpg";

function FadeAnimation() {
  const [CurrentImg, setCurrentImg] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const FadeAnimationData = [
    {
      image: fadeimg1,
      msg: "you can trust us",
    },
    {
      image: fadeimg2,
      msg: "your goods are safe with us",
    },
    {
      image: fadeimg3,
      msg: "We will put a smile on your face",
    },
  ];

  //////////////////////////////////////////////////////////////////

  const nextPhoto = () => {
    setCurrentImg(
      CurrentImg === FadeAnimationData.length - 1 ? 0 : CurrentImg + 1
    );
  };

  const previousPhoto = () => {
    setCurrentImg(
      CurrentImg === 0 ? FadeAnimationData.length - 1 : CurrentImg - 1
    );
  };

  //////////////////////////////////////////////////////////////////

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true); // Trigger fading animation
      setTimeout(() => {
        setCurrentImg((prev) =>
          prev === FadeAnimationData.length - 1 ? 0 : prev + 1
        );
        setIsFading(false); // Reset fading animation after transition
      }, 2000); // Match animation duration
    }, 4000); // Show eachc image for 4 seconds (2s fade + 2s display)

    return () => clearInterval(interval); // Cleanup on unmount
  }, [FadeAnimationData]);
  ///////////////////////////////////////////////////////////////////

  return (
    <FadeAnimationsCon>
      <center>
        <div id="fademancont_id fadeinimg_Anima">
          <div className="FadeGrid fadeinimg_Anima">
            <img
              src={FadeAnimationData[CurrentImg].image}
              alt="Fade Animation"
              id="myimage"
              className={isFading ? "fade" : ""}
            />
            <div className="Desc">{FadeAnimationData[CurrentImg].msg}</div>
            <div className="btns">
              <button onClick={previousPhoto}>Previous</button>
              <button onClick={nextPhoto}>Next</button>
            </div>
          </div>
        </div>
      </center>
    </FadeAnimationsCon>
  );
}

export default FadeAnimation;

const FadeAnimationsCon = styled.div`
  overflow: hidden;
  position: relative;

  .FadeGrid {
    text-align: center;
  }

  center .btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    top: -250px;
  }

  center .btns button {
    border: none;
    padding: 16px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
  }

  .FadeGrid img {
    background-color: red;
    height: 350px;
    width: 100%;
    object-fit: cover;
    animation: fadeIn 2s;
    position: relative;
    transition: opacity 2s ease-in-out; /* Smooth fade effect */
    opacity: 1;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  img.fade {
    opacity: 0; /* Start fading out */
  }
`;
